import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import SiteHeader from "../SiteHeader/SiteHeader";
import Topbar from "../Topbar/Topbar";
import Footer from "../Footer/Footer";
import { useMsal } from "@azure/msal-react";
import { Button } from "react-bootstrap";
import { loginRequest } from "../../auth/authConfig";
import LoginIcon from "../../img/ms-icon.png";
import "./Style/Login.css";

const Login = (): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { instance } = useMsal();

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  return (
    <>
      <Topbar />
      <SiteHeader showText={"Lernzeitkonto Login"}></SiteHeader>

      <div className="login-container">
        <Container className="text-center">
          <h4 style={{ marginBottom: 20 }}>Anmeldung per Browser mit M365-wbsedu Account</h4>
          <Button className="py-3 px-5" onClick={() => handleLoginRedirect()}>
            <img style={{ marginRight: 10 }} width={20} src={LoginIcon} alt="LoginIcon" />
            Anmelden mit Azure AD (Microsoft)
          </Button >
        </Container>

        <Footer />
      </div>
    </>
  );
};

export default Login;
